<template>
  <View align="center" gap="md">
    <Divider />
    <div class="or">or</div>
    <Divider />
  </View>
</template>

<script setup lang="ts">
import Divider from './divider.vue';
import View from './view/view.vue';
</script>

<style scoped lang="scss">
.or {
  line-height: 1.375rem;
  color: var(--t-color-neutral-700);
}
</style>
